import { render } from "./patrol.vue?vue&type=template&id=c70f5640"
import script from "./patrol.vue?vue&type=script&lang=js"
export * from "./patrol.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__